export default class AutoRotatingSliderImprovement {
	start() {
		this.AutoRotatingSliderImprovements();
	}

	AutoRotatingSliderImprovements() {
		$(window).load(() => {
			$('.swiper-container').each((i, slider) => {
				const swiper = slider.swiper;
				const sliderObj = $(slider).parent();
				const isAutoplay = sliderObj.data('props').autoplay;
				const isPauseOnHover = sliderObj.data('props').pause_onhover;
				if (isAutoplay === 'on') {
					this.autoRotationSliderImprovement(sliderObj, swiper, isPauseOnHover);
				}
			});
		});
	}

	autoRotationSliderImprovement(slider, swiper, isPauseOnHover) {
		const ariaLabelDiv = slider.parent().find('.ariaLabelList');
		const ariaLabelFromDataSet = ariaLabelDiv.data('arialabel');
		const mainContainerAriaLabel = ariaLabelFromDataSet.main_container_aria_label;
		const startAriaLabel = ariaLabelFromDataSet.start_button_aria_label;
		const pauseAriaLabel = ariaLabelFromDataSet.pause_button_aria_label;
		slider.attr('aria-label', mainContainerAriaLabel);
		const sliderButton = slider.parent().find('.fl-rotation-control-button');
		sliderButton.click((e) => {
			if (sliderButton.hasClass('pause')) {
				sliderButton.toggleClass('pause play');
				sliderButton.attr('aria-label', startAriaLabel);
				e.preventDefault();
				swiper.autoplay.stop();
				if (isPauseOnHover === 'on') {
					$(slider).find('.swiper-container').css('pointer-events', 'none');
				}
			} else {
				sliderButton.toggleClass('play pause');
				sliderButton.attr('aria-label', pauseAriaLabel);
				e.preventDefault();
				swiper.autoplay.start();
				if (isPauseOnHover === 'on') {
					$(slider).find('.swiper-container').removeAttr('style');
				}
			}
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/slider/controllers/auto-rotating-slider-improvement.js